const config = {
    version: '2022-02-07 (v1.1.6)'
  };
  
export default config;